import { twMerge } from 'tailwind-merge'
import { useAudioElapsedTime } from '@renderer/hooks/audio/useAudioElapsedTime'
import { AUDIO_INDICATOR_COLOR, useAudioIndicatorTone } from '@renderer/hooks/audio/use-audio-indicator-tone'

interface AudioElapsedTimeProps {
  visible?: boolean
}

export function AudioElapsedTime({ visible = true }: AudioElapsedTimeProps) {
  const elapsedTime = useAudioElapsedTime()
  const tone = useAudioIndicatorTone()

  if (!visible) {
    return null
  }

  return (
    <div className="flex items-center overflow-hidden">
      <div className={twMerge('whitespace-nowrap text-sm font-medium tabular-nums', AUDIO_INDICATOR_COLOR[tone])}>
        {elapsedTime}
      </div>
    </div>
  )
}
